/*
PURPOSE: Editorial page section shell — background surface, centred content
container, and consistent vertical rhythm for the base1 refresh.
USE CASES:
- Every Home2 section composes from this instead of re-deriving section
  padding / max-width / background classes inline.
DOMAIN BOUNDARIES:
- Presentation only. No copy, no data. Text/markup passed as children.
- No imports from design-sandbox/ (removal-bound).
*/

import React from 'react';

type EditorialBackground = 'ivory' | 'cream' | 'white';

interface EditorialSectionProps {
  background?: EditorialBackground;
  /** Render the thin top hairline between stacked sections. Default true. */
  topRule?: boolean;
  id?: string;
  /** Extra classes on the inner content container. */
  className?: string;
  children: React.ReactNode;
}

const BG_CLASS: Record<EditorialBackground, string> = {
  ivory: 'bg-ivory',
  cream: 'bg-cream',
  white: 'bg-white',
};

const EditorialSection: React.FC<EditorialSectionProps> = ({
  background = 'ivory',
  topRule = true,
  id,
  className,
  children,
}) => {
  return (
    <section
      id={id}
      className={`${BG_CLASS[background]} ${topRule ? 'border-t border-editorial-muted/10' : ''}`}
    >
      <div
        className={`max-w-screen-xl mx-auto px-6 md:px-12 py-editorial-y md:py-editorial-y-lg ${className ?? ''}`}
      >
        {children}
      </div>
    </section>
  );
};

export default EditorialSection;
